/* Baseline Brewing — storefront funnel interactivity.
   No build step, no dependencies. Reads everything from data-*
   attributes rendered by Liquid, so placeholder and real-product
   data behave identically. */
(function () {
  'use strict';

  /* Shopify's standard money formatter, so JS-computed amounts match
     the store's currency format (the same one Liquid's `money` uses). */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) { return '0'; }
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }
    var match = (format || '').match(placeholder);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return (format || '€{{amount}}').replace(placeholder, value);
  }

  /* ---- Age gate (per-browser, localStorage) ----
     Returning visitors are hidden before paint by the head script
     (.bb-age-ok class); here we only handle the accept click. The
     coming-soon holding screen has no accept button, so it stays. */
  document.querySelectorAll('[data-age-accept]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      try { localStorage.setItem('bb_age_ok', '1'); } catch (e) {}
      var gate = btn.closest('[data-age-gate]');
      if (gate) { gate.hidden = true; }
    });
  });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('[data-faq-q]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.bb-faq__item');
      if (!item) { return; }
      var open = item.classList.toggle('is-open');
      var sign = btn.querySelector('.bb-faq__sign');
      if (sign) { sign.textContent = open ? '−' : '+'; }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---- Gallery thumbnails ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var stage = g.querySelector('[data-gallery-stage]');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-thumb-src');
        if (stage && src) { stage.setAttribute('src', src); }
      });
    });
  });

  /* ---- Buy rail: pack selector + qty + add to cart ---- */
  document.querySelectorAll('[data-buy-rail]').forEach(function (rail) {
    var moneyFmt  = rail.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}';
    var ctaLabel  = rail.getAttribute('data-cta-label') || 'Add to cart';
    var threshold = parseInt(rail.getAttribute('data-threshold'), 10) || 0;
    var packs     = Array.prototype.slice.call(rail.querySelectorAll('[data-pack-key]'));
    var qtyEl     = rail.querySelector('[data-qty-val]');
    var addBtn    = rail.querySelector('[data-add]');
    var meterFill = rail.querySelector('[data-meter-fill]');
    var meterText = rail.querySelector('[data-meter-text]');
    var meterRight= rail.querySelector('[data-meter-right]');
    var warn      = rail.querySelector('[data-rail-warn]');
    var qty = 1;
    var active = null;

    function money(cents) {
      return formatMoney(cents, moneyFmt);
    }

    function pickDefault() {
      var def = packs.filter(function (p) { return p.getAttribute('data-default') === 'true'; })[0];
      var avail = packs.filter(function (p) { return p.getAttribute('data-available') === 'true'; });
      return def || avail[0] || packs[0];
    }

    function setActive(pack) {
      if (!pack) { return; }
      active = pack;
      packs.forEach(function (p) {
        var on = p === pack;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      render();
    }

    function render() {
      if (!active) { return; }
      var price = parseInt(active.getAttribute('data-price'), 10) || 0;
      var subtotal = price * qty;
      if (qtyEl) { qtyEl.textContent = qty; }

      if (addBtn) {
        var hasProduct = active.getAttribute('data-has-product') === 'true';
        var available  = active.getAttribute('data-available') === 'true';
        var ok = hasProduct && available;
        addBtn.textContent = ctaLabel + ' · ' + money(subtotal);
        addBtn.disabled = !ok;
        addBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
        // The "connect a product" notice shows only while a slot is still on placeholder data.
        if (warn) { warn.hidden = hasProduct; }
      }

      if (meterFill && threshold > 0) {
        var pct = Math.min(100, Math.round((subtotal / threshold) * 100));
        meterFill.style.width = pct + '%';
        var remaining = Math.max(0, threshold - subtotal);
        if (meterText) { meterText.textContent = remaining > 0 ? (money(remaining) + ' from free shipping') : 'Free shipping unlocked'; }
        if (meterRight) { meterRight.textContent = money(subtotal) + ' / ' + money(threshold); }
      }
    }

    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        // Block selecting a real product that's sold out; placeholders stay selectable.
        if (p.getAttribute('data-has-product') === 'true' && p.getAttribute('data-available') !== 'true') { return; }
        setActive(p);
      });
    });

    var inc = rail.querySelector('[data-qty-inc]');
    var dec = rail.querySelector('[data-qty-dec]');
    if (inc) { inc.addEventListener('click', function () { qty = Math.min(99, qty + 1); render(); }); }
    if (dec) { dec.addEventListener('click', function () { qty = Math.max(1, qty - 1); render(); }); }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled || !active) { return; }
        var vid = active.getAttribute('data-vid');
        if (!vid) { return; }
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] })
        })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            window.location.href = '/cart';
          })
          .catch(function () { addBtn.disabled = false; });
      });
    }

    setActive(pickDefault());
  });

  /* ---- Cart page: qty steppers, remove, upsell add ---- */
  document.querySelectorAll('[data-cart]').forEach(function (cart) {
    function change(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function () { window.location.reload(); });
    }

    cart.querySelectorAll('[data-line-item]').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var q = parseInt(row.getAttribute('data-qty'), 10) || 1;
      var inc = row.querySelector('[data-cart-inc]');
      var dec = row.querySelector('[data-cart-dec]');
      var rem = row.querySelector('[data-cart-remove]');
      if (inc) { inc.addEventListener('click', function () { change(key, Math.min(99, q + 1)); }); }
      if (dec) { dec.addEventListener('click', function () { change(key, q - 1); }); }   // 0 removes the line
      if (rem) { rem.addEventListener('click', function () { change(key, 0); }); }
    });

    cart.querySelectorAll('[data-cart-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) { return; }
        var vid = btn.getAttribute('data-vid');
        if (!vid) { return; }
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
        })
          .then(function () { window.location.reload(); })
          .catch(function () { btn.disabled = false; });
      });
    });
  });
})();
